/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var k = require("lexical"),
    m = require("@lexical/utils");

var p = /*#__PURE__*/function (_k$ElementNode) {
  _inherits(p, _k$ElementNode);

  var _super = _createSuper(p);

  function p(a, b) {
    var _this;

    _classCallCheck(this, p);

    _this = _super.call(this, b);
    _this.__ids = a || [];
    return _this;
  }

  _createClass(p, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(p.prototype), "exportJSON", this).call(this)), {}, {
        ids: this.getIDs(),
        type: "mark",
        version: 1
      });
    }
  }, {
    key: "createDOM",
    value: function createDOM(a) {
      var b = document.createElement("mark");
      m.addClassNamesToElement(b, a.theme.mark);
      1 < this.__ids.length && m.addClassNamesToElement(b, a.theme.markOverlap);
      return b;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM(a, b, c) {
      a = a.__ids.length;
      var d = this.__ids.length;
      c = c.theme.markOverlap;
      a !== d && (1 === a ? 2 === d && m.addClassNamesToElement(b, c) : 1 === d && m.removeClassNamesFromElement(b, c));
      return !1;
    }
  }, {
    key: "hasID",
    value: function hasID(a) {
      var b = this.getIDs();

      for (var c = 0; c < b.length; c++) {
        if (a === b[c]) return !0;
      }

      return !1;
    }
  }, {
    key: "getIDs",
    value: function getIDs() {
      var a = this.getLatest();
      return r(a) ? a.__ids : [];
    }
  }, {
    key: "addID",
    value: function addID(a) {
      var b = this.getWritable();

      if (r(b)) {
        var c = b.__ids;
        b.__ids = c;

        for (b = 0; b < c.length; b++) {
          if (a === c[b]) return;
        }

        c.push(a);
      }
    }
  }, {
    key: "deleteID",
    value: function deleteID(a) {
      var b = this.getWritable();

      if (r(b)) {
        var c = b.__ids;
        b.__ids = c;

        for (b = 0; b < c.length; b++) {
          if (a === c[b]) {
            c.splice(b, 1);
            break;
          }
        }
      }
    }
  }, {
    key: "insertNewAfter",
    value: function insertNewAfter(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      a = this.getParentOrThrow().insertNewAfter(a, b);
      return k.$isElementNode(a) ? (b = q(this.__ids), a.append(b), b) : null;
    }
  }, {
    key: "canInsertTextBefore",
    value: function canInsertTextBefore() {
      return !1;
    }
  }, {
    key: "canInsertTextAfter",
    value: function canInsertTextAfter() {
      return !1;
    }
  }, {
    key: "canBeEmpty",
    value: function canBeEmpty() {
      return !1;
    }
  }, {
    key: "isInline",
    value: function isInline() {
      return !0;
    }
  }, {
    key: "extractWithChild",
    value: function extractWithChild(a, b, c) {
      if (!k.$isRangeSelection(b) || "html" === c) return !1;
      var d = b.anchor,
          h = b.focus;
      a = d.getNode();
      c = h.getNode();
      b = b.isBackward() ? d.offset - h.offset : h.offset - d.offset;
      return this.isParentOf(a) && this.isParentOf(c) && this.getTextContent().length === b;
    }
  }, {
    key: "excludeFromCopy",
    value: function excludeFromCopy(a) {
      return "clone" !== a;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "mark";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      return new p(Array.from(a.__ids), a.__key);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return null;
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = q(a.ids);
      b.setFormat(a.format);
      b.setIndent(a.indent);
      b.setDirection(a.direction);
      return b;
    }
  }]);

  return p;
}(k.ElementNode);

function q(a) {
  return k.$applyNodeReplacement(new p(a));
}

function r(a) {
  return a instanceof p;
}

exports.$createMarkNode = q;

exports.$getMarkIDs = function (a, b) {
  for (; null !== a;) {
    if (r(a)) return a.getIDs();

    if (k.$isTextNode(a) && b === a.getTextContentSize()) {
      var c = a.getNextSibling();
      if (r(c)) return c.getIDs();
    }

    a = a.getParent();
  }

  return null;
};

exports.$isMarkNode = r;

exports.$unwrapMarkNode = function (a) {
  var b = a.getChildren(),
      c = null;

  for (var d = 0; d < b.length; d++) {
    var h = b[d];
    null === c ? a.insertBefore(h) : c.insertAfter(h);
    c = h;
  }

  a.remove();
};

exports.$wrapSelectionInMarkNode = function (a, b, c, d) {
  var h = a.getNodes();
  var t = a.anchor.offset,
      l = a.focus.offset;
  a = h.length;
  var y = b ? l : t;
  t = b ? t : l;
  var u, f;

  for (l = 0; l < a; l++) {
    var e = h[l];
    if (k.$isElementNode(f) && f.isParentOf(e)) continue;
    var n = 0 === l;
    var w = l === a - 1;
    var g = null;

    if (k.$isTextNode(e)) {
      g = e.getTextContentSize();
      var x = n ? y : 0,
          v = w ? t : g;
      if (0 === x && 0 === v) continue;
      e = e.splitText(x, v);
      g = 1 < e.length && (3 === e.length || n && !w || v === g) ? e[1] : e[0];
    } else if (r(e)) continue;else k.$isElementNode(e) && e.isInline() && (g = e);

    null !== g ? g && g.is(u) || (n = g.getParent(), null != n && n.is(u) || (f = void 0), u = n, void 0 === f && (f = (d || q)([c]), g.insertBefore(f)), f.append(g)) : f = u = void 0;
  }

  k.$isElementNode(f) && (b ? f.selectStart() : f.selectEnd());
};

exports.MarkNode = p;